class AocClickToScroll {
  constructor(container) {
    this.container = container;
    this.header = document.querySelector('header');
    this.backToTopBtn = document.querySelector('.aoc-back-to-top');

    this.onClick = this.onClick.bind(this);
    this.onBackToTop = this.onBackToTop.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onAnchorHover = this.onAnchorHover.bind(this);

    this.container.addEventListener('click', this.onClick);
    this.container.addEventListener('mouseover', this.onAnchorHover);
    this.backToTopBtn?.addEventListener('click', this.onBackToTop);
    window.addEventListener('scroll', this.onScroll);

    this.backToTopBtn?.classList.add('is-hidden');
  }

  onAnchorHover(e) {
    const anchor = e.target.closest('.anchor');
    if (!anchor) return;

    const index = anchor.dataset.bannerIndex;

    // hide all banners
    this.container.querySelectorAll('.banner-item').forEach((item) => {
      item.classList.remove('is-visible');
      item.classList.add('is-hidden');
    });

    // show the matching banner
    const matchingBanner = this.container.querySelector(`.banner-item[data-banner-index="${index}"]`);
    if (matchingBanner) {
      matchingBanner.classList.remove('is-hidden');
      matchingBanner.classList.add('is-visible');
    }
  }

  onClick(e) {
    const anchor = e.target.closest('.anchor');
    if (!anchor) return;

    const targetId = anchor.dataset.target;
    const target = document.getElementById(targetId);
    if (!target) return;

    const scrollTo = target;
    const headerHeight = this.header?.offsetHeight || 0;
    const top = scrollTo.getBoundingClientRect().top + window.scrollY - headerHeight - 300;

    window.scrollTo({ top, behavior: 'smooth' });
  }

  onBackToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onScroll() {
    if (!this.backToTopBtn) return;
    const threshold = this.container.offsetTop + this.container.offsetHeight;
    this.backToTopBtn.classList.toggle('is-hidden', window.scrollY < threshold);
  }

  destroy() {
    this.container.removeEventListener('click', this.onClick);
    this.container.removeEventListener('mouseover', this.onAnchorHover);
    this.backToTopBtn?.removeEventListener('click', this.onBackToTop);
    window.removeEventListener('scroll', this.onScroll);
  }
}


/* ================================
   Section initialization
================================ */

const instances = {};

function init(scope = document) {
  scope.querySelectorAll('[data-section-type="aoc-click-to-scroll"]').forEach((container) => {
    const id = container.dataset.sectionId;

    if (instances[id]) {
      instances[id].destroy();
      delete instances[id];
    }

    instances[id] = new AocClickToScroll(container);
  });
}

document.addEventListener('DOMContentLoaded', () => init());

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e) => init(e.target));
}

document.addEventListener('shopify:section:unload', (e) => {
  const id = e.detail.sectionId;
  if (instances[id]) {
    instances[id].destroy();
    delete instances[id];
  }
});